import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { 
  UserList, 
  UserProfile, 
  UserAdminUpdate, 
  UserSearchCriteria,
  UserProfileAdmin
} from '../../_models/user.model';
import { ApiResponse } from '../../_models/api-response.model';
import { Page } from '../../_models/page.model';

@Injectable({
  providedIn: 'root'
})
export class AdminUserService {
  private apiUrl = `${environment.apiUrl}/users`;

  constructor(private http: HttpClient) {}

  // Get all users with search criteria
  getAllUsers(
    criteria: UserSearchCriteria = {},
    page: number = 0, 
    size: number = 10, 
    sort: string = 'createdAt', 
    direction: string = 'DESC'
  ): Observable<ApiResponse<Page<UserList>>> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('sort', sort)
      .set('direction', direction);

    if (criteria.search) {
      params = params.set('search', criteria.search);
    }
    if (criteria.isEnabled !== undefined) {
      params = params.set('isEnabled', criteria.isEnabled.toString());
    }
    if (criteria.emailVerified !== undefined) {
      params = params.set('emailVerified', criteria.emailVerified.toString());
    }

    return this.http.get<ApiResponse<Page<UserList>>>(this.apiUrl, { params });
  }

  // Get user details by ID
  getUserDetails(userId: number): Observable<ApiResponse<UserProfileAdmin>> {
    return this.http.get<ApiResponse<UserProfileAdmin>>(`${this.apiUrl}/${userId}`);
  }

  // Enable user
  enableUser(userId: number): Observable<ApiResponse<void>> {
    return this.http.post<ApiResponse<void>>(`${this.apiUrl}/${userId}/enable`, {});
  }

  // Disable user
  disableUser(userId: number): Observable<ApiResponse<void>> {
    return this.http.post<ApiResponse<void>>(`${this.apiUrl}/${userId}/disable`, {});
  }

  // Verify user email
  verifyUserEmail(userId: number): Observable<ApiResponse<void>> {
    return this.http.post<ApiResponse<void>>(`${this.apiUrl}/${userId}/verify-email`, {});
  }

  // Update user
  updateUser(userId: number, updateData: UserAdminUpdate): Observable<ApiResponse<UserProfileAdmin>> {
    return this.http.put<ApiResponse<UserProfileAdmin>>(`${this.apiUrl}/${userId}`, updateData);
  }

  // Delete user
  deleteUser(userId: number): Observable<ApiResponse<void>> {
    return this.http.delete<ApiResponse<void>>(`${this.apiUrl}/${userId}`);
  }
}